//COPIED FROM CONFLUENCE

import window from 'window-or-global';
import { getLink } from '../../facades/confluence';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

/**
 * Confluence TinyMCE plugin. Creates controls and commands for:
 * - inserting images
 * - macro browser
 * - unlinking
 *
 * TODOXHTML: clean this up and split into separate TinyMCE plugins
 */

export function confluencePlugin() {
	const plugger = () => {
		return {
			init(ed) {
				ed.addCommand('mceConfUnlink', (ui, val) => {
					const s = ed.selection;
					let n = val || s.getNode();
					let $n = $(n);

					if (n.nodeName !== 'A') {
						const parent = $n.closest('a');
						if (!parent.length) {
							return;
						}
						n = parent[0];
						$n = parent;
					}

					let href = $n.attr('href');
					if (!href) {
						// fix broken links before attempting to unlink
						href = '#';
						$n.attr('href', href);
					}
					// unlinking external links requires wrapping it a span with a class
					// so we don't automatically convert them to links on the server
					const removeTrailingSlash = function (text) {
						const trailingSlashRegexResult = /(.*)[\/]$/.exec(text);
						return trailingSlashRegexResult != null ? trailingSlashRegexResult[1] : text;
					};
					if (
						!$n.attr('data-linked-resource-id') &&
						getLink().isExternalLink(href) &&
						$n.text() == removeTrailingSlash(href)
					) {
						const span = ed.dom.create('span', { class: 'nolink' }, href);
						ed.dom.replace(span, n, false);
					} else {
						s.select(n);
						// Firefox doesn't remove link classes when it unlinks so we remove them manually
						$n.removeClass('createlink unresolved');
						ed.execCommand('UnLink');
					}
				});

				// Register buttons
				ed.addButton('confimage', {
					title: 'confluence.confimage_desc',
					cmd: 'mceConfimage',
				});
				ed.addButton('conf_macro_browser', {
					title: 'confluence.conf_macro_browser_desc',
					cmd: 'mceConfMacroBrowser',
				});
			},

			getInfo() {
				return {
					longname: 'Confluence TinyMCE Plugin',
					author: 'Atlassian',
					authorurl: 'http://www.atlassian.com',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.ConfluencePlugin', plugger());
	window.tinymce.PluginManager.add('confluence', window.tinymce.plugins.ConfluencePlugin);
}

export function confluencePluginWRM() {
	return ['wr!com.atlassian.confluence.plugins.confluence-link-browser:link-object'];
}
